import {
    IonButton,
    IonContent,
    IonHeader,
    IonPage,
    IonTitle,
    IonToolbar,
    useIonRouter,
    useIonToast
} from "@ionic/react";

import {
    useEffect,
    useState
} from "react";

import {
    isAuthenticated,
    logoutFantasy
} from "../services/auth";

import "./LogIn.css";

const Account: React.FC = () => {
    const router = useIonRouter();

    const [present] = useIonToast();

    const [loggingOut, setLoggingOut] =
        useState(false);

    useEffect(
        function () {
            if (!isAuthenticated()) {
                router.push(
                    "/home",
                    "root",
                    "replace"
                );
            }
        },
        [router]
    );

    async function logOut(): Promise<void> {
        if (loggingOut) {
            return;
        }

        try {
            setLoggingOut(true);

            await logoutFantasy();

            present({
                message: "Sesión cerrada correctamente.",
                duration: 1800,
                position: "middle",
                color: "success"
            });

            router.push(
                "/home",
                "root",
                "replace"
            );
        } catch (error: unknown) {
            console.error(
                "No fue posible cerrar sesión:",
                error
            );

            present({
                message:
                    "No fue posible cerrar sesión correctamente.",
                duration: 2200,
                position: "middle",
                color: "danger"
            });
        } finally {
            setLoggingOut(false);
        }
    }

    return (
        <IonPage>
            <IonHeader>
                <IonToolbar>
                    <IonTitle>MexFBA</IonTitle>
                </IonToolbar>
            </IonHeader>

            <IonContent>
                <div className="container1">
                    <IonButton
                        color="danger"
                        disabled={loggingOut}
                        onClick={function () {
                            void logOut();
                        }}
                    >
                        {loggingOut
                            ? "Cerrando sesión..."
                            : "Cerrar sesión"}
                    </IonButton>
                </div>
            </IonContent>
        </IonPage>
    );
};

export default Account;